import React from 'react';
import {trackEvent} from '../../utils/tracking.js';
import PropTypes from 'prop-types';
import { withGigCardContext } from '../gig_card_context';
import { getItByDate } from '../../utils/getItByDate';
import './style.scss';

const MAX_DELIVERY_TIME = 7;

const DeliveryTime = ({ gigUrl, deliveryTime, cardType, cardSize }) => {
    const shouldDisplayDeliveryTime = deliveryTime > 0 && deliveryTime < MAX_DELIVERY_TIME;

    return (
        <div className="get-it-by">
            {
                shouldDisplayDeliveryTime &&
                (
                    <a href={gigUrl}
                        onClick={() => trackEvent('delivery_time', cardType, cardSize)}>
                        <span> {i18n.t('delivery_time.get_it_by')} <strong>{getItByDate(deliveryTime)}</strong></span>
                    </a>
                )
            }
        </div>
    );
};

DeliveryTime.propTypes = {
    gigUrl: PropTypes.string,
    deliveryTime: PropTypes.number,
    cardType: PropTypes.string
};

const contextSelector = ({ cardType, cardSize }) => ({ cardType, cardSize });

export default withGigCardContext(contextSelector)(DeliveryTime);



// WEBPACK FOOTER //
// ./src/shared/delivery_time/index.js